import { ICellRendererAngularComp } from 'ag-grid-angular';
import {
  Component,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-color-renderer',
    template: `
    <input type="color" [(ngModel)]="color" (ngModelChange)="colorChanged($event)" [disabled]="!params.colDef.editable">
  `,
    styles: [`
    input {
      width: 100%;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      height: 24px;
      position: absolute;
      border: none;
    }
  `],
    standalone: true,
    imports: [FormsModule],
})
export class ColorRendererComponent implements ICellRendererAngularComp {

  @ViewChild('container', { read: ViewContainerRef })
  public container!: ViewContainerRef;
  public color = '#FFFFFF';
  public params: any;

  agInit(params: any): void {
    this.params = params;
    this.color = params.value;
  }

  refresh(): boolean {
    return false;
  }

  public colorChanged(color: string): void {
    this.params.context.colorUpdated(this.params.node.data.id, color);
  }

}
